export const GET_INCLUSIONS_SUMMARY = 'GET_INCLUSIONS_SUMMARY'
export const GET_INCLUSIONS_SUMMARY_FAILED = 'GET_INCLUSIONS_SUMMARY_FAILED'
export const GET_INCLUSIONS_SUMMARY_SUCCESS = 'GET_INCLUSIONS_SUMMARY_SUCCESS'

export const GET_INCLUSIONS = 'GET_INCLUSIONS'
export const GET_INCLUSIONS_FAILED = 'GET_INCLUSIONS_FAILED'
export const GET_INCLUSIONS_SUCCESS = 'GET_INCLUSIONS_SUCCESS'

export const GET_FILE_PDF = 'GET_FILE_PDF'
export const GET_FILE_PDF_SUCCESS = 'GET_FILE_PDF_SUCCESS'
export const GET_FILE_PDF_FAILED = 'GET_FILE_PDF_FAILED'
export const SET_INCLUSIONS_USER_SETTINGS = 'SET_INCLUSIONS_USER_SETTINGS'


export const UPDATE_INCLUSION_MAKER_READED =
    'UPDATE_INCLUSION_MAKER_READED'
export const UPDATE_INCLUSION_MAKER_READED_SUCCESS =
    'UPDATE_INCLUSION_MAKER_READED_SUCCESS'
export const UPDATE_INCLUSION_MAKER_READED_FAILED =
    'UPDATE_INCLUSION_MAKER_READED_FAILED'
